import angular from 'angular';
import employeesComponent from './employees.component';

let employeesModule = angular.module('employees', [
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
})

.component('employees', employeesComponent);

export default employeesModule;



// WEBPACK FOOTER //
// ./client/pages/admin/employees/employees.js